<template>
  <div>
    <div class="tip-match-box-wrap">
      <div class="tip-match-box-content">
        <div class="tip-match-box-close" />
        <div class="tip-match-box-open" />
        <div class="tip-match-gold-wrap">
          <img
            v-for="(item,index) in 5"
            :key="item"
            :src="`https://image-1251917893.file.myqcloud.com/box/${index + 1}.png`"
            :class="['tip-match-gold-img',`img-${index + 1}`]"
          >
        </div>
      </div>
    </div>

    <TipMatchPopupContainer
      v-if="isShowPopup"
      :is-show="isShowPopup"
      :is-showpopup-close="isShowpopupClose"
      :popup-title="isGamePrize ? '恭喜获得游戏礼包' : '恭喜获得'"
      @onCancel="dimissDialog"
    >
      <div
        v-if="isGamePrize"
      >
        <scroll-view
          scroll-y="true"
          class="tip-match-award"
        >
          <p class="tip-match-tip">
            仅展示游戏礼包，其他奖品已发放至<span
              class="tip-math-go"
              @click.stop="onGoAward"
            >【我的奖品】</span>，请自行兑换。
          </p>
          <PropsCheck :props-check-list="awardList" />
        </scroll-view>
        <div class="tip-match-btn-wrap">
          <div class="tip-match-btn-info">
            <p>发放到游戏邮箱：</p>
            <div
              class="tip-match-role"
              @click.stop="onShowSwitchRoleDialog"
            >
              <p>{{ curRoleName }}</p>
              <div class="iconfont icon-change" />
            </div>
          </div>
          <div
            class="tip-match-btn"
            @click.stop="onExchange"
          >
            确认领取
          </div>
        </div>
      </div>

      <div v-else>
        <scroll-view
          scroll-y="true"
          class="tip-match-award"
        >
          <PropsCheck :props-check-list="awardList" />
        </scroll-view>
        <div
          class="tip-match-go-award"
        >
          <PressButton
            type="e-sport-primary-bg-xl"
            @click.stop="onGoAward"
          >
            查看奖励
          </PressButton>
        </div>
      </div>
    </TipMatchPopupContainer>

    <!-- 未获得奖励 -->
    <CommTipDialog
      v-if="tipTitle"
      :show="isShowTipDialog"
      :title="tipTitle"
      :confirm-text="confirmText"
      :cancel-text="cancelText"
      @confirm="onConfirm"
      @cancel="onCancel"
    />
  </div>
</template>
<script>
import TipMatchPopupContainer from '@tencent/press-ui/press-popup/press-popup';
import CommTipDialog from '@tencent/press-ui/press-dialog/press-dialog';
import PropsCheck from 'src/local-component/ui/tip-match/tip-match-props-get-award';
import PressButton from '@tencent/press-ui/press-button/press-button';
export default {
  components: {
    TipMatchPopupContainer,
    CommTipDialog,
    PropsCheck,
    PressButton,
  },
  props: {
    tipTitle: {
      type: String,
      desc: '提示标题',
      default: '',
    },
    confirmText: {
      type: String,
      desc: '高亮按钮文案',
      default: '',
    },
    cancelText: {
      type: String,
      desc: '置灰按钮文案',
      default: '',
    },
    curRoleName: {
      type: String,
      default: '角色名',
    },
    awardList: {
      type: Array,
      desc: '推荐列表',
      default: () => [{
        propsPic: 'https://dummyimage.com/200x200',
        propsName: '道具名称',
        propsLabel: '皮肤',
        propsPrice: '18.88',
        propsNum: '1',
        isShowCheck: false,
        isChecked: false,
      }, {
        propsPic: 'https://dummyimage.com/200x200',
        propsName: '道具名称',
        propsLabel: '皮肤',
        propsPrice: '18.88',
        propsNum: '1',
        isShowCheck: false,
        isChecked: false,
      }, {
        propsPic: 'https://dummyimage.com/200x200',
        propsName: '道具名称',
        propsLabel: '皮肤',
        propsPrice: '18.88',
        propsNum: '1',
        isShowCheck: false,
        isChecked: false,
      }],
      required: false,
    },
    isGamePrize: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    'confirm',
    'dimissDialog',
    'onShowSwitchRoleDialog',

    'onExchange',
    'onConfirm',
    'onCancel',
    'onGoAward',
  ],
  options: {
    virtualHost: true,
  },
  data() {
    return {
      isShowpopupClose: true,
      // 是否显示中奖弹窗
      isShowPopup: false,
      // 是否显示未中奖弹窗
      isShowTipDialog: false,
    };
  },
  mounted() {
    setTimeout(() => {
      // 已中奖或者有奖励
      if (this.awardList.length > 0) {
        this.isShowTipDialog = false;
        this.isShowPopup = true;
      } else { // 未中奖或者没有奖励
        this.isShowPopup = false;
        this.isShowTipDialog = true;
      }
    }, 1200);
  },
  methods: {
    dimissDialog() {
      this.$emit('dimissDialog');
      this.isShowPopup = false;
    },
    confirm() {
      this.$emit('confirm');
    },
    onShowSwitchRoleDialog() {
      this.$emit('onShowSwitchRoleDialog');
    },
    onExchange() {
      this.$emit('onExchange');
    },
    onConfirm() {
      this.isShowTipDialog = false;
      this.$emit('onConfirm');
    },
    onCancel() {
      this.$emit('onCancel');
    },
    onGoAward() {
      this.$emit('onGoAward');
    },
  },
};

</script>
<style lang="scss" scoped src="./css/index.scss"></style>
